import type { ReactNode } from 'react'
import { ChevronRight } from 'lucide-react'
import { clsx } from 'clsx'

// Tappable row: leading slot · title + subtitle · trailing slot (defaults to a
// chevron when the row navigates).
export function ListItem({
  leading,
  title,
  subtitle,
  trailing,
  onClick,
  chevron,
  className,
}: {
  leading?: ReactNode
  title: ReactNode
  subtitle?: ReactNode
  trailing?: ReactNode
  onClick?: () => void
  chevron?: boolean
  className?: string
}) {
  const Tag = onClick ? 'button' : 'div'
  return (
    <Tag
      onClick={onClick}
      className={clsx(
        'flex items-center gap-3 w-full text-left px-4 min-h-[var(--tap)] py-2',
        onClick && 'active:bg-[var(--line-soft)] transition-colors',
        className,
      )}
    >
      {leading && <span className="shrink-0">{leading}</span>}
      <span className="flex-1 min-w-0">
        <span className="block truncate font-medium text-[length:var(--fs-md)]">{title}</span>
        {subtitle && (
          <span className="block truncate text-[length:var(--fs-sm)] text-[color:var(--fg-muted)]">{subtitle}</span>
        )}
      </span>
      {trailing ?? (chevron && <ChevronRight size={20} className="shrink-0 text-[color:var(--fg-faint)]" />)}
    </Tag>
  )
}
